module.exports = __webpack_public_path__ + "static/rootbeer-8505a9549c18ba8b9173eb3af419f23c.jpg";